import { render } from "./ChangePwdDialog.vue?vue&type=template&id=2a900f66&ts=true"
import script from "./ChangePwdDialog.vue?vue&type=script&lang=ts"
export * from "./ChangePwdDialog.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/fe/keyan-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__